export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/UT-ea60c9a0fabc763fbb75843c1eb26467.PNG";